import { fade, makeStyles } from '@material-ui/core/styles';
import colors from 'global/styles/colors';

const useStyles = makeStyles((theme) => ({
  appBar: {},
  templateBar: {
    position: 'relative',
    backgroundColor: fade(colors.danger, 0.25),
    padding: theme.spacing(2),
    fontStyle: 'italic',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  icon: {
    marginRight: theme.spacing(1),
    height: '21px',
  },
  content: {
    maxWidth: '100%',
    height: '100%',
  },
  fab: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1),
  },
}));

export default useStyles;
